import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const LetterWithAnalyticsOutline = createIcon({
  displayName: 'LetterWithAnalyticsOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path d="M0,24H24V0H0" fill="none" />
      <path d="M3,8V6A3,3,0,0,1,6,3H7" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path
        d="M21,15v3a3,3,0,0,1-3,3H16"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <rect
        x="3"
        y="11"
        width="10"
        height="10"
        rx="3"
        strokeWidth="1.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1="10.03505"
        y1="15.25"
        x2="8.53505"
        y2="16.75"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="8.53505"
        y1="16.75"
        x2="7.28505"
        y2="15.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="7.28505"
        y1="15.5"
        x2="6.03505"
        y2="16.75"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M16,12h2.75A2.25,2.25,0,0,0,21,9.75V5.25A2.25,2.25,0,0,0,18.75,3h-6.5A2.25,2.25,0,0,0,10,5.25V8"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M13,6.5l1.98914.8908a1.25,1.25,0,0,0,1.02181,0L18,6.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const LetterWithAnalytics: FC<IconProps> = (props) => {
  return <CustomIcon as={LetterWithAnalyticsOutline} {...props} />
}

export default memo(LetterWithAnalytics)
